import styled from "styled-components";

// Left-side specific wrappers for VehicleInformation
export const VehicleInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 28px;
  align-items: start;
`;

export const VehicleInfoLeft = styled.div`
  display: flex;
  flex: 4;
  flex-direction: column;
  gap: 32px;
`;

export const VehicleInfoRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 5;
`;

export const VehicleInfoImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const VehicleInfoInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const VehicleInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const VehicleInfoVINWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;